<template>
  <section>
    <h3 class="display-1 mt-4">
      Общие сведения
    </h3>

    <v-simple-table>
      <template v-slot:default>
        <tbody>
          <tr>
            <td>Тест</td>
            <td>{{ test.name }}</td>
          </tr>
          <tr>
            <td>Дата</td>
            <td>{{ session.finished | datetime }}</td>
          </tr>
          <tr>
            <td>Продолжительность</td>
            <td>{{ session.duration }}</td>
          </tr>
          <tr>
            <td><b>Правильные ответы</b></td>
            <td>
              <b>{{ session.score }} из {{ session.count }}</b>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <h3 class="display-1 mt-4">
      Результат подробно
    </h3>
    <v-simple-table>
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">Раздел</th>
            <th class="text-right">Результат</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in sections" :key="item.key">
            <td class="text-left">{{ item.name }}</td>
            <td class="text-right">{{ item.score }} из {{ item.cnt }}</td>
          </tr>
          <tr>
            <td class="text-left">
              <b>{{ report[0].name }}</b>
            </td>
            <td class="text-right">
              <b>{{ report[0].score }} из {{ report[0].cnt }}</b>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <template v-if="achievements.length">
      <h3 class="display-1 mt-4">
        Достижения
      </h3>
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-right">N</th>
              <th class="text-left">Название</th>
              <th class="text-right">Очки</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in achievements" :key="item.code">
              <td class="text-right">{{ index + 1 }}</td>
              <td>
                {{ item.achievement }}
              </td>
              <td class="text-right">{{ item.score }}</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </template>
  </section>
</template>

<script>
export default {
  name: 'Report',
  props: {
    session: {
      type: Object,
      required: true
    },
    test: {
      type: Object,
      required: true
    },
    report: {
      type: Object,
      required: true
    },
    achievements: {
      type: Array,
      required: true
    }
  },
  computed: {
    sections() {
      return Object.entries(this.report)
        .map(([key, item]) => ({ ...item, key }))
        .filter(e => e.key !== '0')
    }
  }
}
</script>

<style scoped>
ul.minibullets {
  list-style-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' version='1.1'  width='18' height='18' viewBox='0 0 18 18'><path fill='#777' d='M10,17L15,12L10,7V17Z' /></svg> ");
  list-style-position: outside;
  margin-left: 0;
  padding-left: 20px;
  line-height: 24px;
}

ul.minibullets > li:not(:last-child) {
  border-bottom: 1px dotted #999;
}

ul.minibullets > li .score {
  float: right;
}

ul.microbullets {
  list-style-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' version='1.1'  width='18' height='18' viewBox='0 0 18 18'><path fill='#777' d='M10,17L15,12L10,7V17Z' /></svg> ");
  list-style-position: outside;
  margin-top: 0;
  margin-left: 0;
  padding-left: 20px;
}

ul.microbullets > li {
  margin: 0;
}
</style>
